import React from 'react';
import {
  Icon,
  Segment,
  Dimmer,
  Loader
} from 'semantic-ui-react'

import Circle from './Circle';
import Wrapper from './Wrapper';

const LoadingIndicator = () => (
  <Dimmer active inverted>
    <Loader size='massive' />
  </Dimmer>
);

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./app/components/LoadingIndicator/index.js